import Vue from 'vue';
import RzSDK from '@razlet/sdk';

export default function ({ store }) {
  // eslint-disable-next-line no-extend-native
  Array.prototype.at = function (index) {
    const realIndex = index >= 0 ? index : this.length + index;
    return this[realIndex];
  };
  // eslint-disable-next-line no-extend-native
  String.prototype.at = function (index) {
    const realIndex = index >= 0 ? index : this.length + index;
    return this.charAt(realIndex);
  };
  Vue.use(RzSDK, { store });
}
